// Ultra simple FOUC prevention
// This script removes the loading state as soon as possible

// Remove loading state immediately
document.documentElement.classList.remove('js-loading');
document.documentElement.classList.add('js-loaded');

// Hide loading indicator
window.addEventListener('DOMContentLoaded', function() {
  var loadingIndicator = document.querySelector('.loading-indicator');
  if (loadingIndicator) {
    loadingIndicator.style.display = 'none';
  }
});

// Fallback - remove loading state after 300ms no matter what
setTimeout(function() {
  document.documentElement.classList.remove('js-loading');
  document.documentElement.classList.add('js-loaded');
  
  var loadingIndicator = document.querySelector('.loading-indicator');
  if (loadingIndicator) {
    loadingIndicator.style.display = 'none';
  }
}, 300);
